import { MissingDeclaredFeature } from '../data-qa-types';
import { InlineAlert } from './InlineAlert';

interface MissingDeclaredFeaturesAlertProps {
  missingDeclaredFeatures: MissingDeclaredFeature[];
}

// Features the model's config declares that its data frame doesn't carry -- the model has
// no data for them.
export const MissingDeclaredFeaturesAlert = ({
  missingDeclaredFeatures
}: MissingDeclaredFeaturesAlertProps) => {
  const count = missingDeclaredFeatures.length;
  if (count === 0) return undefined;

  return (
    <InlineAlert
      variant='warning'
      title={`${count} feature${count === 1 ? '' : 's'} in this model’s config ${count === 1 ? 'isn’t' : 'aren’t'} in the data frame`}
    >
      The config declares {count === 1 ? 'it' : 'them'} in <code>paid_media_exposure_vars</code>,
      but the data frame has no column for {count === 1 ? 'it' : 'them'}, so the model has no data
      for {count === 1 ? 'it' : 'them'}. If the config is out of date with the data frame, it needs
      updating before the model is trained.
      <ul className='data-qa-missing-declared__list'>
        {missingDeclaredFeatures.map(f => (
          <li key={f.featureId}>
            <strong>{f.feature || 'Unnamed feature'}</strong> ({f.featureId})
          </li>
        ))}
      </ul>
    </InlineAlert>
  );
};
